import axios from "axios";
import { ResponseAPIWithPagination } from "../../../common/types/API.types";
import { Momi, MomiPatch } from "../types/momiTypes";

const BACKEND_URL = process.env.REACT_APP_BACKEND_API_URL + '/api/v1';

export const getAllMomis = async (currentPage: number, pageSize: number, querySearch?: string) => {
    const params = "currentPage=" + currentPage + "&pageSize=" + pageSize;
    const filterParams = "orderByQuery=-momi_updated_at" + (querySearch ? "&query=" + querySearch : "");
    return (await axios.get<ResponseAPIWithPagination<Momi>>(`${BACKEND_URL}/momis?${params}&${filterParams}`)).data;
}

export const getSingleMomi = async (momiId: string) => {
    return (await axios.get<Momi>(`${BACKEND_URL}/momis/${momiId}`)).data;
}

export const createMomi = async (momi: MomiPatch) => {
    return (await axios.post<Momi>(`${BACKEND_URL}/momis`, momi)).data;
}

export const updateMomi = async (momiId: string, momi: Momi) => {
    return (await axios.put<Momi>(`${BACKEND_URL}/momis/${momiId}`, momi)).data;
}

export const deleteMomi = async (momiId: string) => {
    return (await axios.delete<null>(`${BACKEND_URL}/momis/${momiId}`)).data;
}

export const momiAPI = {
    getAllMomis,
    getSingleMomi,
    createMomi,
    updateMomi,
    deleteMomi,
}

export default momiAPI
